import API from "@/models/API";

export default class History {
    static getMonthlyPoints = (query) =>
        API.get(
            `/stores/${localStorage.getItem("storeId")}/history/monthly-points${query}`
        );

    static getPointAnalysis = (query) =>
        API.get(
            `/stores/${localStorage.getItem("storeId")}/history/points${query}`
        );

    static getExportedMonthlyPointsStatus = () =>
        API.get(
            `/stores/${localStorage.getItem(
                "storeId"
            )}/export/store-monthly-point-history`
        );

    static exportMonthlyPoints = item =>
        API.post(
            `/stores/${localStorage.getItem(
                "storeId"
            )}/export/store-monthly-point-history`,
            item
        );

    static deleteExportedMonthlyPoints = id =>
        API.delete(
            `/stores/${localStorage.getItem(
                "storeId"
            )}/export/store-monthly-point-history/${id}`
        );

    static getExportedPointAnalysisStatus = () =>
        API.get(
            `/stores/${localStorage.getItem(
                "storeId"
            )}/export/store-point-analysis`
        );

    static exportPointAnalysis = item =>
        API.post(
            `/stores/${localStorage.getItem(
                "storeId"
            )}/export/store-point-analysis`,
            item
        );

    static deleteExportedPointAnalysis = id =>
        API.delete(
            `/stores/${localStorage.getItem(
                "storeId"
            )}/export/store-point-analysis/${id}`
        );
}
